import initialState from "../state/initialState"

const formReducer = (state, action) => {
    switch (action.type) {
        case 'SET_FORM_TYPE':
            return {
                ...state ,
                formType:  action.payload
            }
        case 'SET_FORM_TEMPLATES_LIST':
            return {
                ...state ,
                formTemplatesList:  action.payload
            }
        case 'SET_FORMS_TEMPLATES':
            return {
                ...state ,
                formsTemplates:  action.payload
            }
        case 'SET_TEMPLATES':
            return {
                ...state ,
                selectedTemplates:  action.payload
            }
        case 'SET_FORM_STATE':
            return {
                ...state,
                formState: action.payload
            }
        case 'SET_FORM_STATE_ERRORS':
            return {
                ...state,
                formErrors: action.payload
            }
        case 'SET_LOADING':
            return {
                ...state,
                loading: action.payload
            }
        case 'SET_ERROR':
            return {
                ...state,
                error: action.payload 
            }
        case 'SET_ALERT':
            return {
                ...state,
                alert: action.payload 
            }
        case 'SET_FORM_INFO':
            return {
                ...state,
                formInfo: action.payload
            }
        case 'SET_FORM_SIGNATORIES':
            return {
                ...state,
                formSignatories: action.payload
            }
        case 'SET_USER_DETAILS':
            return {
                ...state,
                userDetails: action.payload
            }
        case 'SET_AGENT_DETAILS':
            return {
                ...state,
                agentDetails: action.payload
            }
        case 'SET_ALL_AGENT_NAMES':
            return {
                ...state,
                agentNames: action.payload
            }
        case 'SET_PARTIES_FIELDS':
            return {
                ...state,
                partiesFieldsCount: action.payload
            }
        case 'SET_SUPPORTING_DOCS':
            return {
                ...state,
                supportingDocuments: action.payload
            }
        case 'SET_SHARED_FORMS':
            return {
                ...state,
                sharedForms: action.payload
            }
        case 'RESET_FORM_STATE':
            return {
                ...initialState,
                loading: false,
                agentNames: state.agentNames,
                userDetails: state.userDetails,
                agentDetails: state.userDetails, //reset to logged in user
                formTemplatesList: state.formTemplatesList
            }

        default:
            return state
    }
}


export default formReducer
